export default __webpack_public_path__ + "static/media/metamask.8d34b885.png";